module.exports = __webpack_public_path__ + "img/eedenn.ca1b1d77.jpg";